import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import KpiReportTable from "./components/KpiReportTable";
import { FaSpinner } from "react-icons/fa";

const KpiReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("KPI Report"));
  }, []);
  const [kPIReportData, setKPIReportData] = useState([]);
  console.log("kPIReportData",kPIReportData);
  
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const columns = {
    // ID: { text: "ID", align: "start" },
    ClientName: { text: " Name", align: "left", width: "400px", visible: true },
  };

  const [reportTypeOptions, setReportTypeOptions] = useState([
    { value: 1, label: "Projected KPI Report" },
    { value: 2, label: "Actual KPI Report" },
    { value: 3, label: "Difference" },
  ]);
  const formDatas = [
    {
      name: "Select Month",
      type: "Date",
    },
    {
      name: "Report Type",
      type: "Select",
      options: [...reportTypeOptions],
    },
  ];

  const [filterFormData, setFilterData] = useState([
    { value: moment(new Date()).format("MMMM, YYYY"), label: "Select Month" },
    { value: 1, label: "Report Type" },
  ]);
  const [selectedMonthLabel, setSelectedMonthLabel] = useState(
    moment(new Date()).format("MMMM, YYYY")
  );
 
  const handleChange = (e, name) => {
    // Store the selected month label in a separate state
    if (name === "Select Month") {
      setSelectedMonthLabel(e);
    }

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e,
          },
        ];
      }
    });
  };
  const [currentDate, setCurrentDate] = useState("");
  const [previousDate, setPreviousDate] = useState("");

  useEffect(() => {
    if (selectedMonthLabel) {
      const options = { year: "numeric", month: "long" };
      const makeDate = new Date(selectedMonthLabel);

      // Format current date
      const formattedCurrent = makeDate.toLocaleDateString("en-US", options);
      setCurrentDate(formattedCurrent);

      // Calculate and format previous month
      makeDate.setMonth(makeDate.getMonth() - 1);
      const formattedPrevious = makeDate.toLocaleDateString("en-US", options);
      setPreviousDate(formattedPrevious);
    }
  }, [selectedMonthLabel]);
const [apiStatus,setApiStatus] = useState('')
const [totalCost,setTotalCost] = useState("")
const [totalInvAmt,setTotalInvAmt] = useState("")
  const [filterValue,setFilterValue]=useState(0)
  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rom-report/14?date=${
          filterFormData.find((o) => o.label === "Select Month")
            ? moment(
                filterFormData.find((o) => o.label === "Select Month").value
              ).format("YYYY-MM")
            : 0
        }&ReportType=${
          filterFormData.find((o) => o.label === "Report Type")
            ? filterFormData.find((o) => o.label === "Report Type").value
            : 0
        }`
      );
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
console.log("cleanedData",cleanedData);

        const filterValue = filterFormData.find(
          (o) => o.label === "Report Type"
        )
          ? filterFormData.find((o) => o.label === "Report Type").value
          : 0;
          setFilterValue(filterValue)
          console.log("filterValue",filterValue);
          setTotalInvAmt(cleanedData?.invoiceTotal)
          setTotalCost(cleanedData?.costTotal)
        setKPIReportData(cleanedData?.[`data${filterValue}`]);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      setApiStatus('')
      console.error("Error fetching PartnerMaster:", error);
    }
  };


    const ReadOnlyValues =[
    {
    label:" Total Inv. Amt",value:Number(totalInvAmt).toLocaleString("en-IN")
  },
    {
    label:" Total Cost",value:Number(totalCost).toLocaleString("en-IN")
  },
    
]
  return (
    <div className="container-fluid " id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
       <div className="row mt-2">
 
    <KpiReportTable
      data={kPIReportData}
      columns={columns}
      itemsPerPage={8}
      ReadOnlyValues={ReadOnlyValues}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      showIcon1={false}
      showIcon2={false}
      showIcon3={false}
      showIcon4={false}
      showIcon5={false}
      formDatas={formDatas}
      isSorting={true}
      filterFormData={filterFormData}
      theadType={filterValue}
      handleGetData={handleGetData}
      isApiStatus={apiStatus}
      isActionRequired={true}
      isFilterRequired={true}
      isCheckBoxRequired={false}
      currentMonth={currentDate}
      previousMonth={previousDate}
      handleChange={handleChange}
      add
      more
      function
      icons={{
        Icon1: <i className="bi bi-pencil-square icons"></i>,
        Icon2: <i className="bi bi-trash-fill icons"></i>,
        Icon3: <i className="bi bi-eye-fill icons"></i>,
        Icon4: <i className="bi bi-person-plus icons"></i>,
        Icon4Text: "Create Employee",
      }}
    />

</div>

      </div>
    </div>
  );
};

export default KpiReport;
